import template from './brands.html';
import './brands.scss';

export class BrandsController {

}

export default {
  controller: BrandsController,
  template,
  transclude: {
    menu: 'brandsMenu',
    list: 'brandsList',
    content: 'brandsContent',
  },
};
